import styled from 'styled-components'

export const ContainerDragAndDropImage = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  width: 100%;
  height: 200px;
  padding: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
  &:hover {
    border: 2px dashed #2b6cb0;
  }

  ${(props) =>
    props.dragging &&
    `
    border: 2px dashed #2b6cb0;
  `}
`
